import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import * as ImageFlowWebsocket from './imageflow.websocket';

export function* imageFlowCreate(action: any): SagaIterator {
  try {
    ImageFlowWebsocket.imageFlowCreate(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* imageFlowDelete(action: any): SagaIterator {
  try {
    ImageFlowWebsocket.imageFlowDelete(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* imageFlowCommentCreate(action: any): SagaIterator {
  try {
    ImageFlowWebsocket.imageFlowCommentCreate(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* imageFlowLike(action: any): SagaIterator {
  try {
    ImageFlowWebsocket.imageFlowLike(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* imageFlowSeen(action: any): SagaIterator {
  try {
    ImageFlowWebsocket.imageFlowSeen(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* imageFlowRequest(action: any): SagaIterator {
  try {
    ImageFlowWebsocket.imageFlowRequest(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 



// WEBPACK FOOTER //
// ./src/services/imageflow/imageflow.saga.ts